import React, {CSSProperties, FC} from "react";

const styles: Record<string, CSSProperties> = {
  base: {
    display: "inline-block",
    borderRadius: "4px",
    fontSize: "0.6rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    padding: "0px 5px",
    verticalAlign: "middle",
  },
  applied: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    border: "1px solid #c8e6c9",
  },
  unapplied: {
    backgroundColor: "#fff8e1",
    color: "#f57f17",
    border: "1px solid #ffe082",
  },
};

interface StatusBadgeProps {
  applied: boolean;
  label?: string;
  style?: CSSProperties;
}

const StatusBadge: FC<StatusBadgeProps> = ({applied, label, style}) => (
  <span
    style={{
      ...styles.base,
      ...(applied ? styles.applied : styles.unapplied),
      ...style,
    }}
  >
    {label ?? (applied ? "Applied" : "Unapplied")}
  </span>
);

export default StatusBadge;
